import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'react-bootstrap';
import './PrivacyPolicySelectionModal.scss';
import {FormattedMessage, useIntl} from 'react-intl';

const getErrorCode = (response) => response?.errorCode || response?.error_code;

const normalizeConsentItems = (response) => {
    const result = response?.result || response?.data || response || {};
    const rawList = Array.isArray(result)
        ? result
        : result?.consentList || result?.purposeList || result?.items || [];

    return rawList?.[0]?.items
        .map((item, index) => {
            const itemId = item?.id || item?.consentId || item?.purposeId || item?.code || `consent-${index + 1}`;
            const content = item?.content || item?.consentName || item?.purposeName || item?.description || item?.content || '';
            if (!content) {
                return null;
            }

            return {
                itemId,
                content,
                isRequired: item?.isRequired,
                itemCode: item?.itemCode,
                // checked: Boolean(item?.checked ?? item?.isChecked ?? item?.accepted),
                checked: Boolean(item?.isRequired === 1),
            };
        })
        .filter(Boolean);
};

const PrivacyPolicySelectionModal = ({
                                         isOpenModal,
                                         closeModal,
                                         closeModalLogin,
                                         listConsent,
                                         msisdn,
                                         selectedIds,
                                         setSelectedIds,
                                         logOut,
                                         handleConfirm,
                                         isSaving,
                                         flow
                                     }) => {
    const [draftSelectedIds, setDraftSelectedIds] = useState([]);
    const intl = useIntl();

    const allChecked = listConsent.length > 0 && draftSelectedIds.length === listConsent.length;
    const requiredIds = listConsent
        .filter((item) => Number(item?.isRequired) === 1)
        .map((item) => item.itemId);
    const hasSelectedAllRequired = requiredIds.every((itemId) => draftSelectedIds.includes(itemId));

    useEffect(() => {
        if (isOpenModal) {
            setDraftSelectedIds(selectedIds);
        }
    }, [isOpenModal, selectedIds]);

    const handleToggleAll = () => {
        if (allChecked) {
            setDraftSelectedIds([]);
            return;
        }
        setDraftSelectedIds(listConsent.map((item) => item.itemId));
    };

    const handleToggleItem = (item) => {
        setDraftSelectedIds((prevState) => {
            if (prevState.includes(item?.itemId)) {
                return prevState.filter((itemId) => itemId !== item?.itemId);
            }
            return [...prevState, item?.itemId];
        });
    };

    const handleConfirmSelection = () => {
        setSelectedIds(draftSelectedIds);
        handleConfirm(draftSelectedIds);
    };

    return (
        <Modal
            show={isOpenModal}
            centered
            dialogClassName="privacy-policy-selection-modal"
        >
            <Modal.Body>
                <button
                    type="button"
                    aria-label={intl.formatMessage({id: 'IDS_BTN_CLOSE'})}
                    onClick={() => {
                        if (flow === 'login') {
                            logOut();
                        }
                        closeModal();
                    }}
                    className="privacy-policy-selection-modal__close-btn"
                >
                    ×
                </button>

                <h3 className="privacy-policy-selection-modal__title">
                    <FormattedMessage id="LOGIN_43"/>
                </h3>
                <p className="privacy-policy-selection-modal__description">
                    <FormattedMessage id="LOGIN_44"/>
                </p>

                <div className="privacy-policy-selection-modal__list">
                    <label className="privacy-policy-selection-modal__row privacy-policy-selection-modal__row--all">
                        <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleToggleAll}
                        />
                        <span><FormattedMessage id="LOGIN_45"/></span>
                    </label>

                    {listConsent.length === 0 && (
                        <div className="privacy-policy-selection-modal__state">
                            <FormattedMessage id="IDS_TV_KHONG_CO_DU_LIEU"/>
                        </div>
                    )}

                    {listConsent.length > 0 && listConsent.map((item, index) => (
                        <label key={`consent-${index + 1}`} className="privacy-policy-selection-modal__row">
                            <input
                                type="checkbox"
                                checked={draftSelectedIds.includes(item.itemId)}
                                onChange={() => handleToggleItem(item)}
                            />
                            <span>{item.content}</span>
                        </label>
                    ))}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    onClick={handleConfirmSelection}
                    className="privacy-policy-selection-modal__confirm-btn"
                    disabled={isSaving || !hasSelectedAllRequired || listConsent.length === 0}
                >
                    {isSaving
                        ? <FormattedMessage id="IDS_TV_DANG_XU_LY"/>
                        : <FormattedMessage id="IDS_TV_XAC_NHAN"/>}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

PrivacyPolicySelectionModal.propTypes = {
    isOpenModal: PropTypes.bool,
    closeModal: PropTypes.func,
    closeModalLogin: PropTypes.func,
    listConsent: PropTypes.array,
    msisdn: PropTypes.string,
    selectedIds: PropTypes.array,
    setSelectedIds: PropTypes.func,
    logOut: PropTypes.func,
    handleConfirm: PropTypes.func,
    isSaving: PropTypes.bool,
    flow: PropTypes.string
};

PrivacyPolicySelectionModal.defaultProps = {
    isOpenModal: false,
    closeModal: () => {
    },
    closeModalLogin: () => {
    },
    listConsent: [],
    selectedIds: [],
    msisdn: '',
    logOut: () => {
    },
    isSaving: false,
    flow: ''
};

export default PrivacyPolicySelectionModal;

